import { Icon, Typography } from '@design-system';
import { getUser } from '@features/auth/auth.slice';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { pageTitles } from './pageTitles';

import './PageTitle.scss';

const getParametrizedPath = (path: string): string | undefined => {
    // Pour chaque clé de pageTitles, on génère une RegExp qui matche le chemin réel
    for (const key of Object.keys(pageTitles)) {
        // Remplace les segments :param par des groupes capturants
        const regexStr = key.replace(/:[^/]+/g, '[^/]+');
        const regex = new RegExp('^' + regexStr + '$');
        if (regex.test(path)) {
            return key;
        }
    }
    return undefined;
};

export const PageTitle: React.FC = () => {
    const location = useLocation();
    const user = useSelector(getUser);
    const parametrizedPath = getParametrizedPath(location.pathname);
    const item = parametrizedPath ? pageTitles[parametrizedPath] : undefined;

    if (!item) {
        return null;
    }

    return (<>
        <div className="page-name">
            <Icon icon={item.icon} size={24} color="secondary" />
            <Typography intrinsic="h2">{item.title}</Typography>
            {item.subtitle && <Typography intrinsic="h3" variant="secondary" color="primary">{item.subtitle}</Typography>}
        </div>
        {item.welcome && user?.firstname &&
            <div className="feature-name">
                <Typography color="primary" intrinsic="h1" variant="secondary">
                    Bonjour <b>{user.firstname}</b>
                </Typography>
            </div>
        }
    </>);
};
